import {
  WARNING_BACKGROUND,
  WARNING_COLOR
} from "../../../../../../../themes/themeConfigurator";

const styles = () => ({
  dialogTitle: {
    background: WARNING_BACKGROUND,
    '& .fa-exclamation-circle': {
      color: WARNING_COLOR,
    }
  }
});

export default styles;